import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft, RotateCcw } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { bookingStore } from "@/domain/booking/booking.store";

export const Route = createFileRoute("/(public)/payment/cancel")({
  component: RouteComponent,
});

function RouteComponent() {
  const { clearBooking } = bookingStore();

  useEffect(() => {
    // Nettoyer le store car le paiement a été annulé
    clearBooking();
  }, [clearBooking]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-50">
      <div className="text-center max-w-lg mx-auto px-4">
        <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
          <XCircle className="w-12 h-12 text-red-600" />
        </div>

        <h1 className="font-h1 text-red-600 mb-4 text-3xl">Paiement annulé</h1>

        <p className="font-p text-muted-foreground mb-6 text-lg">
          Vous avez annulé votre paiement. Aucun montant n'a été débité de votre
          compte.
        </p>

        <div className="bg-white p-6 rounded-lg shadow-md mb-8 border border-red-200">
          <div className="flex items-center justify-center gap-2 mb-3">
            <XCircle className="w-5 h-5 text-red-600" />
            <span className="font-semibold text-red-700">
              Réservation non confirmée
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            Votre réservation n'a pas été finalisée. Le créneau reste disponible
            pour d'autres utilisateurs.
          </p>
        </div>

        <p className="font-p text-muted-foreground mb-8">
          Vous pouvez reprendre votre réservation à tout moment ou explorer
          d'autres options.
        </p>

        <div className="space-y-4">
          <Button asChild className="w-full">
            <Link to="/trouver-un-chef">
              <RotateCcw className="w-4 h-4 mr-2" />
              Reprendre ma recherche
            </Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to="/">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
